import {
  LISTING_SEARCH_MAX_LENGTH,
  LISTING_SEARCH_ARIA_LABELLED_BY,
} from '../../../../../constants/listings'
import classnames from 'classnames'
import { useDispatch } from 'react-redux'
import { useRef, useEffect } from 'react'
import { Button, FormField } from '../../../..'
import { defineMessages, useIntl } from 'react-intl'
import { TEXT } from '../../../../shared/FormField/types'
import { toggleListingSearchModal } from '../../../../../actions/listings'
import { useListingSearchContext } from '../../../../../context/listingSearch'

import styles from './SearchModalInput.module.scss'

export const MSG = defineMessages({
  desc: {
    id: 'SearchModal.describe.description',
    defaultMessage:
      'Type 2 characters to initiate address, zip, county, state, or location search. When autocomplete results are available use up and down arrows to review and enter to select.',
  },
  cancel: {
    id: 'SearchModal.input.cancel',
    defaultMessage: 'Cancel',
  },
})

export const SearchModalInput = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const innerRef = useRef<HTMLInputElement>()
  const {
    inputId,
    inputValue,
    describeId,
    resultsListId,
    handleKeyDown,
    selectedIndex,
    handleOnChange,
    activeDescendantId,
    hasResultsAfterSearch,
  } = useListingSearchContext()

  useEffect(() => {
    innerRef.current?.focus()
  }, [])

  return (
    <div className={styles.container}>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <FormField
        autoFocus
        type={TEXT}
        id={inputId}
        ref={innerRef}
        role='combobox'
        autoCorrect='off'
        value={inputValue}
        autoComplete='off'
        autoCapitalize='off'
        aria-haspopup='listbox'
        aria-autocomplete='list'
        name='listingSearchInput'
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
        aria-owns={resultsListId}
        labelClass={styles.label}
        className={styles.formField}
        maxLength={LISTING_SEARCH_MAX_LENGTH}
        aria-expanded={hasResultsAfterSearch}
        data-active-option={activeDescendantId}
        aria-activedescendant={activeDescendantId}
        aria-labelledby={LISTING_SEARCH_ARIA_LABELLED_BY}
        inputClassName={classnames(
          styles.input,
          selectedIndex !== null && styles.removeFocus
        )}
      >
        <span id={describeId} className={styles.describe}>
          {intl.formatMessage(MSG.desc)}
        </span>
      </FormField>
      <Button
        minimal
        type='submit'
        id='cancelSearchModalBtn'
        className={styles.button}
        onClick={() => dispatch(toggleListingSearchModal(false))}
      >
        {intl.formatMessage(MSG.cancel)}
      </Button>
    </div>
  )
}
